export default "__VITE_ASSET__DYPity3$__"